// extracted by mini-css-extract-plugin
export default {"auto-shrink-text":"N4LsWhJBhqqyTkv6V0NE","middle-layer":"ke1kCzBARxq5HSxbDQ6h","inner-text":"TMZWYZcIv5YQXVdFMVrw","common_bganimation":"oODjhNVXI2p8KmlPzyS5"};